import { makeStyles } from "@material-ui/core";

export default makeStyles(() => ({
    root: {
        position: "relative",
        backgroundColor: "#FFF",
        borderBottom: `1px solid rgba(212, 208, 208, .54)`,
        minHeight: "calc(100vh - 310px)",
    },
}));
